import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import transitions from 'material-ui/styles/transitions';
import * as Colors from 'material-ui/styles/colors';
import _ from 'lodash';
import LoginWidget from 'loginWidget/LoginWidget';
import { getAllDesktopElementsByList, getAllMobileElementsByList } from 'crazyEditor/redux/modules/element/elementSelectors';
import { closeLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import InlineNotification, {LEVEL_NOTICE} from 'crazyEditor/components/EditorUI/BaseUI/InlineMessages/InlineNotification';
import InlineButton from 'shared/components/InlineButton';

const LOGIN_WIDGET_WIDTH = 500;
const LOGIN_WIDGET_HEIGHT = 370;

@connect(
  (state) => ({
    tempUser: state.user.tempUser,
    trialDuration: state.user.trialDuration,
    allDesktopElements: state.element ? getAllDesktopElementsByList(state) : null,
    allMobileElements: state.element ? getAllMobileElementsByList(state) : null,
    listingData: state.listingData,
  }),
  {closeLazyPanel},
)
export default class LoginWidgetDialog extends Component {
  handleClose = (callback) => {
    const {closeLazyPanel, panelName} = this.props;
    closeLazyPanel(panelName);
    if (callback) {
      callback();
    }
  };

  render() {
    const {open, tempUser, trialDuration, panelProps, allDesktopElements, allMobileElements, listingData} = this.props;
    const itemId = _.isEmpty(listingData) ? null : listingData.itemID;
    return (
      <Dialog
        open={open}
        contentStyle={{width: 0, height: 0, position: 'fixed', top: `calc(50% - ${Math.ceil((LOGIN_WIDGET_HEIGHT + 150) / 2) + 64}px)`, left: `calc(50% - ${Math.ceil(LOGIN_WIDGET_WIDTH / 2)}px)`}}
        bodyStyle={{overflowY: 'visible'}}
        onRequestClose={this.handleClose}
      >
        <InlineNotification
          open={!!panelProps.ebayConnectEmail}
          style={{width: LOGIN_WIDGET_WIDTH, marginBottom: 15, transition: transitions.easeOut()}}
          level={LEVEL_NOTICE}
          animate={false}
        >
          {panelProps.duplicateErrorMessage} <br/>
          To continue - login or create a new Crazylister account. <br/>
          <InlineButton
            onClick={() => {
              window.Intercom('showNewMessage',
                'Hello Crazylister\n' +
                'I am having trouble connecting my eBay account (' + panelProps.ebayConnectEmail + ') to Crazylister.\n' +
                'This is the message i get:\n"' +
                panelProps.duplicateErrorMessage +
                '"\nWhat should I do?');
            }}
            style={{color: Colors.blue700}}
          >Ask for help</InlineButton>&nbsp;if you still have any questions.
        </InlineNotification>
        <div style={{minHeight: LOGIN_WIDGET_HEIGHT, width: LOGIN_WIDGET_WIDTH}}>
          <LoginWidget
            tempUser={tempUser}
            trialDuration={trialDuration}
            closeDialog={() => this.handleClose(panelProps.callback)}
            copyTemplateProps={{allDesktopElements, allMobileElements, itemId, returnRedirectUrl: true}}
            ebayConnectEmail={panelProps.ebayConnectEmail}
          />
        </div>
      </Dialog>
    );
  }
}
